import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthHeaderService } from './auth-header.service';
import { map } from 'rxjs/operators'; // Ensure proper import
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  host = environment.APIUrl;

  constructor(private _http: HttpClient, private authHeaderService: AuthHeaderService) { }

  /**
   * Updated Post method with explicit JSON headers
   */
  post(url: string, data: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    return this._http.post(this.host + url, data, { headers }).pipe(
      map(response => response)
    );
  }

  postWithAuth(url: string, data: any) {
    return this._http.post(this.host + url, data, { headers: this.authHeaderService.getHeader() }).pipe(
      map(response => response)
    );
  }

  get(url: string) {
    return this._http.get<any>(this.host + url).pipe(
      map(response => response)
    );
  }

  getWithAuth(url: string) {
    return this._http.get<any>(this.host + url, { headers: this.authHeaderService.getHeader() }).pipe(
      map(response => response)
    );
  }

  downloadGet(path: string) {
    return this._http.get(this.host + path, {
      responseType: 'blob',
      observe: 'response',
    }).pipe(
      map((res: any) => {
        if (res.body) {
          if (res.headers.get('Content-Type') === "application/json") {
            return null;
          } else {
            return {
              data: new Blob([res.body], { type: res.headers.get('Content-Type') }),
              filename: res.headers.get('File-Name')
            };
          }
        }
        return null;
      })
    );
  }

  downloadWithAuth(path: string) {
    // Get your auth headers (token, etc.)
    const authHeaders = this.authHeaderService.getHeader();

    return this._http.get(this.host + path, {
      headers: authHeaders,      // Added Auth Headers here
      responseType: 'blob',      // Required for PDF/Files
      observe: 'response',       // Required to read filename from headers
    }).pipe(
      map((res: any) => {
        if (res.body) {
          // Safety check if the API returns JSON error instead of file
          if (res.headers.get('Content-Type')?.includes("application/json")) {
            return null;
          } else {
            return {
              data: new Blob([res.body], { type: res.headers.get('Content-Type') }),
              filename: res.headers.get('File-Name') || 'download.pdf'
            };
          }
        }
        return null;
      })
    );
  }

  // FIXED: Added authenticated POST blob processor method required by your sales service refactor
  downloadPostWithAuth(path: string, data: any) {
    const authHeaders = this.authHeaderService.getHeader();

    return this._http.post(this.host + path, data, {
      headers: authHeaders,
      responseType: 'blob', // Tells Angular to parse binary buffer layout strings cleanly
      observe: 'response'   // Allows access to header files for downstream name reads
    }).pipe(
      map((res: any) => {
        if (res.body) {
          if (res.headers.get('Content-Type')?.includes("application/json")) {
            return null;
          } else {
            return {
              data: new Blob([res.body], { type: res.headers.get('Content-Type') }),
              filename: res.headers.get('File-Name') || 'Invoice.pdf'
            };
          }
        }
        return null;
      })
    );
  }
}
